import React, { useState } from 'react';

export default function OrganisationMark({ branding, className = '', fallbackClassName = '' }) {
  const [imageFailed, setImageFailed] = useState(false);
  const name = branding?.organisationName || 'Organisation';
  const showImage = branding?.showOrganisationLogo !== false && !imageFailed;

  if (showImage) {
    return (
      <img
        src="/brand/organisation-logo.png"
        alt={name}
        className={className}
        onError={() => setImageFailed(true)}
      />
    );
  }

  return (
    <div className={fallbackClassName} aria-label={name} title={name}>
      {name.charAt(0).toUpperCase()}
    </div>
  );
}
